export function getFirstName(name: string) {
  const tokens = name.split(" ");
  return tokens[0];
}
